/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";

//custom libraries
import { Table, Thead, Tbody, Tr, Th, Td, Pagination } from "../components";
import { dollarFormat } from "../helpers/dataFormat";

export interface TableRowProps {
  partNumber: string;
  address: string;
  quantity: number;
  unitPrice: any;
  orderItemPrice: any;
}

const TableRow: React.FC<TableRowProps> = ({
  partNumber,
  address,
  quantity,
  unitPrice,
  orderItemPrice,
}) => {
  return (
    <>
      <Tr>
        <Td>{partNumber}</Td>
        <Td>{address}</Td>
        <Td>{quantity}</Td>
        <Td>{unitPrice}</Td>
        <Td>{orderItemPrice}</Td>
      </Tr>
    </>
  );
};

interface OrderItemsTableProps {
  getPrevious: Function;
  getNext: Function;
  orderItem: any[];
  orderDetail: any;
}

const OrderItemsTable: React.FC<OrderItemsTableProps> = ({
  getPrevious,
  getNext,
  orderItem,
  orderDetail,
}) => {
  const orderItemArray: any[] = orderItem;
  const { t, i18n } = useTranslation();
  let tableRows: any[] = [];
  const locale = i18n.language;
  const currency = orderDetail.grandTotalCurrency;

  if (orderItemArray && orderItemArray.length > 0) {
    orderItemArray.forEach((orderItem: any, index: number) => {
      let address1 = "";
      orderItem["addressLine"].forEach((e: any) => {
        const addressLine = e.trim();
        if (addressLine) {
          address1 = `${address1} ${addressLine} `;
        }
      });
      address1 = `${address1},${orderItem["postalCode"]}`;

      tableRows.push(
        <TableRow
          key={`tableRow${index}`}
          partNumber={orderItem["partNumber"]}
          address={address1}
          quantity={Number(orderItem["quantity"])}
          unitPrice={
            currency &&
            dollarFormat(Number(orderItem["unitPrice"]), locale, currency)
          }
          orderItemPrice={
            currency &&
            dollarFormat(Number(orderItem["orderItemPrice"]), locale, currency)
          }
        />
      );
    });
  }

  return (
    <>
      <Table>
        <Thead>
          <Tr>
            <Th>{t("OrderManagement.OrderItemDetails.ItemNumber")}</Th>
            <Th>{t("OrderManagement.OrderItemDetails.ShippingAddress")}</Th>
            <Th>{t("OrderManagement.OrderItemDetails.Quantity")}</Th>
            <Th>{t("OrderManagement.OrderItemDetails.Each")}</Th>
            <Th>{t("OrderManagement.OrderItemDetails.Total")}</Th>
          </Tr>
        </Thead>
        <Tbody>{tableRows}</Tbody>
      </Table>
      {orderItemArray && orderItemArray.length > 0 && (
        <Pagination
          getPrev={getPrevious}
          getNext={getNext}
          offset={Number(orderDetail.recordSetStartNumber)}
          limit={Number(orderDetail.recordSetCount)}
          count={Number(orderDetail.recordSetTotal)}
        />
      )}
    </>
  );
};

export default OrderItemsTable;
